import { Component, Input} from '@angular/core';
import {MatDialog } from '@angular/material/dialog';
import {DialogImportDataComponent} from './import-data-dialog/import-data-dialog.component';
import {TableType} from 'src/shared/enums';

@Component({
    standalone: false,
    selector: 'import-button',
    templateUrl: './import-button.component.html',
    styleUrls: ['./import-button.component.scss']

})
export class ImportButtonComponent {

    @Input() public table: any;

    @Input() public tableType: TableType;

    constructor(public dialog: MatDialog) {
    }

    public openDialog(): void {
        this.dialog.open(DialogImportDataComponent, {
            width: '400px',
            height: '350px',
            data: {
                table: this.table,
                type: this.tableType
            }
        });
    }

}


